/**
 * FOC product-tour deep links for the requirements catalog.
 * Leaf module (string literals only) to avoid circular imports with tour steps.
 */

export const ORG_WORKSPACE_TOUR_HREF = '/hub?openTab=AORs&orgWorkspaceTour=1';
export const FOC_PLANNING_TOUR_HREF =
  '/hub?openTab=PlanLibrary&focPlanningTour=1';
export const HUB_COP_TOUR_HREF = '/hub?openTab=Layers&hubCopTour=1';
export const SITL_COP_TOUR_HREF = '/hub?sitlCopTour=1';
export const FOC_COP_LAYERS_TOUR_HREF =
  '/hub?openTab=Layers&focCopLayersTour=1';
export const FOC_FSLTP_TOUR_HREF = '/hub?openTab=Layers&focFsltpTour=1';
export const FOC_NOTIFICATIONS_TOUR_HREF =
  '/hub?openTab=Notifications&focNotificationsTour=1';
export const FOC_INCIDENTS_TOUR_HREF =
  '/hub?openTab=Incidents&focIncidentsTour=1';
export const FOC_INCIDENT_ROSTER_TOUR_HREF =
  '/hub?openTab=Incidents&focIncidentRosterTour=1';
export const FOC_INITIAL_RESPONSE_TOUR_HREF =
  '/hub?openTab=Incidents&focInitialResponseTour=1';
export const FOC_TRANSITION_TOUR_HREF =
  '/hub?openTab=Incidents&focTransitionTour=1';
export const FOC_PLANNING_P_MODEL_TOUR_HREF =
  '/hub?openTab=Incidents&focPlanningPModelTour=1';
export const FOC_PLANNING_P_MEETING_TOUR_HREF =
  '/hub?openTab=Incidents&focPlanningPMeetingTour=1';
export const FOC_PLANNING_P_COMMAND_STAFF_TOUR_HREF =
  '/hub?openTab=Incidents&focPlanningPCommandStaffTour=1';
export const FOC_PLANNING_P_PREP_TACTICS_TOUR_HREF =
  '/hub?openTab=Incidents&focPlanningPPrepTacticsTour=1';
export const FOC_PLANNING_P_TACTICS_WORKFLOW_TOUR_HREF =
  '/hub?openTab=Incidents&focPlanningPTacticsWorkflowTour=1';
export const FOC_PLANNING_P_TACTICS_MEETING_TOUR_HREF =
  '/hub?openTab=Incidents&focPlanningPTacticsMeetingTour=1';
export const FOC_PLANNING_PREP_TOUR_HREF =
  '/hub?openTab=Incidents&focPlanningPrepTour=1';
export const FOC_IAP_PREP_TOUR_HREF =
  '/hub?openTab=Incidents&focIapPrepTour=1';
export const FOC_IAP_FORMS_TOUR_HREF =
  '/hub?openTab=Incidents&focIapFormsTour=1';
export const FOC_WS_TOUR_HREF = '/hub?focWsTour=1';
export const FOC_CMD_IC_TOUR_HREF = '/hub?focCmdIcTour=1';
export const FOC_CMD_SAFETY_TOUR_HREF = '/hub?focCmdSafetyTour=1';
export const FOC_CMD_LIAISON_TOUR_HREF = '/hub?focCmdLiaisonTour=1';
export const FOC_CMD_PIO_TOUR_HREF = '/hub?focCmdPioTour=1';
export const FOC_CMD_LEGAL_TOUR_HREF = '/hub?focCmdLegalTour=1';
export const FOC_PLN_PSC_TOUR_HREF = '/hub?focPlnPscTour=1';
export const FOC_PLN_SITL_TOUR_HREF = '/hub?focPlnSitlTour=1';
export const FOC_PLN_RESOURCE_TOUR_HREF = '/hub?focPlnResourceTour=1';
export const FOC_PLN_DOCS_TOUR_HREF = '/hub?focPlnDocsTour=1';
export const FOC_PLN_DEMOB_TOUR_HREF = '/hub?focPlnDemobTour=1';
export const FOC_OPS_TOUR_HREF = '/hub?focOpsTour=1';
export const FOC_LOG_TOUR_HREF = '/hub?focLogTour=1';
export const FOC_RES_MODEL_TOUR_HREF =
  '/hub?openTab=Resources&focResModelTour=1';
export const FOC_RES_213RR_TOUR_HREF =
  '/hub?openTab=Resources&focRes213rrTour=1';
export const FOC_RES_211_TOUR_HREF =
  '/hub?openTab=Resources&focRes211Tour=1';
export const FOC_RES_214_TOUR_HREF =
  '/hub?openTab=Resources&focRes214Tour=1';
export const FOC_DMOB_TOUR_HREF = '/hub?focDmobTour=1';
export const FOC_EXT_TOUR_HREF = '/hub?openTab=Incidents&focExtTour=1';
export const FOC_AI_IOC_TOUR_HREF = '/hub?focAiIocTour=1';
export const FOC_AI_FOC_TOUR_HREF = '/hub?focAiFocTour=1';
